<template>
	<div class="recharge-page">
		<!-- 页面内容 -->
		<div class="page-content">
			<!-- 页面顶部Banner -->
			<section class="page-banner">
				<div class="banner-container">
					<h1 class="banner-title">FF币充值</h1>
					<p class="banner-subtitle">FF币可用于课程学习、认证考试、AI咨询等服务</p>
				</div>
			</section>

			<!-- 面包屑导航 -->
			<!-- <Breadcrumb /> -->

			<!-- 主要内容 -->
			<main class="main-content">
				<div class="container">
					<!-- 页面标题 -->
					<div class="page-header">
						<h1 class="page-title">FF币充值</h1>
						<p class="page-subtitle">FF币可用于课程学习、认证考试、AI咨询等服务</p>
					</div>

					<!-- 充值区域 -->
					<div class="recharge-container">
						<!-- 左侧：充值选项 -->
						<div class="recharge-left">
							<div class="recharge-panel">
								<h3 class="recharge-title">选择充值金额</h3>

								<!-- 预设金额选项 -->
								<div class="amount-options">
									<div v-for="option in amountOptions" :key="option.id" class="amount-option"
										:class="{ selected: selectedAmount === option.money }"
										@click="selectAmount(option)">
										<div class="bonus-tag">{{ option.bonusText }}</div>
										<div class="amount-ff">{{ option.ff.toLocaleString() }}FF币</div>
										<div class="amount-money">¥{{ option.money }}</div>
									</div>
								</div>

								<!-- 支付方式 -->
								<div class="payment-methods">
									<h4 class="payment-title">选择支付方式</h4>
									<div class="payment-options">
										<div v-for="method in paymentMethods" :key="method.id" class="payment-option"
											:class="{ selected: selectedPayment === method.id }"
											@click="selectedPayment = method.id">
											<div class="payment-icon" :class="method.class">
												<svg v-if="method.id === 'wechat'" width="24" height="24"
													viewBox="0 0 24 24" fill="currentColor">
													<path
														d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.298c-.1.333.326.548.637.405l1.613-.744a.79.79 0 0 1 .529-.074c.739.135 1.513.202 2.297.202.387 0 .771-.016 1.147-.049-.07-.284-.109-.577-.109-.879 0-3.727 3.537-6.75 7.898-6.75.571 0 1.124.06 1.658.17-.602-3.514-4.086-6.324-8.805-6.324z" />
													<path
														d="M6.054 7.64c.639 0 1.156-.518 1.156-1.156S6.693 5.328 6.054 5.328a1.156 1.156 0 1 0 0 2.312z" />
													<path
														d="M11.327 7.64c.639 0 1.156-.518 1.156-1.156s-.517-1.156-1.156-1.156a1.156 1.156 0 1 0 0 2.312z" />
													<path
														d="M24 14.188c0-3.297-3.537-5.976-7.899-5.976C11.74 8.212 8.203 10.89 8.203 14.188c0 3.297 3.537 5.976 7.898 5.976.527 0 1.046-.065 1.551-.182a.79.79 0 0 1 .529.074l1.075.496c.246.113.537-.142.455-.398l-.26-.869a.59.59 0 0 1 .213-.665C22.83 18.39 24 16.4 24 14.188z" />
													<path
														d="M14.327 13.032a.578.578 0 1 0 0-1.156.578.578 0 0 0 0 1.156z" />
													<path
														d="M17.673 13.032a.578.578 0 1 0 0-1.156.578.578 0 0 0 0 1.156z" />
												</svg>
												<span v-else>{{ method.icon }}</span>
											</div>
											<div class="payment-name">{{ method.name }}</div>
										</div>
									</div>
								</div>

								<!-- 充值按钮 -->
								<button class="recharge-btn" :disabled="!canRecharge || isLoading"
									@click="handleRecharge">
									<span v-if="isLoading" class="loading">
										<div class="spinner"></div>
										生成二维码中...
									</span>
									<span v-else>
										立即充值 {{ finalAmount > 0 ? `¥${finalAmount}` : '' }}
									</span>
								</button>
							</div>
							<!-- 充值/消费记录 -->
							<div class="records-section">
								<div class="records-tabs">
									<button :class="['record-tab', { active: activeTab === 'recharge' }]"
										@click="switchTab('recharge')">
										充值记录
									</button>
									<button :class="['record-tab', { active: activeTab === 'consume' }]"
										@click="switchTab('consume')">
										消费记录
									</button>
								</div>

								<div class="records-content">
									<!-- 充值记录 -->
									<div v-if="activeTab === 'recharge'">
										<!-- 充值记录列表 -->
										<div v-for="(record, index) in rechargeHistory" :key="index"
											class="record-item">
											<div class="record-info">
												<div class="record-title">FF币充值</div>
												<div class="record-date">{{ record.createTime }}</div>
											</div>
											<div class="record-amount positive">+{{ record.amount/100 }}</div>
										</div>

										<!-- 空状态 -->
										<div v-if="rechargeHistory.length === 0" class="empty-records">
											<div class="empty-icon">💰</div>
											<div>暂无充值记录</div>
										</div>
									</div>

									<!-- 消费记录 -->
									<div v-if="activeTab === 'consume'">
										<!-- 消费记录列表 -->
										<div v-for="(record, index) in consumeHistory" :key="index" class="record-item">
											<div class="record-info">
												<div class="record-title">FF币消费</div>
												<div class="record-date">{{ record.createTime }}</div>
											</div>
											<div class="record-amount negative">{{ record.amount }}</div>
										</div>

										<!-- 空状态 -->
										<div v-if="consumeHistory.length === 0" class="empty-records">
											<div class="empty-icon">📊</div>
											<div>暂无消费记录</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 右侧：余额信息 -->
						<div>
							<!-- 当前余额 -->
							<div class="balance-card">
								<div class="balance-title">当前FF币余额</div>
								<div class="balance-amount">{{ tokenBalance}}</div>
							</div>
						</div>
					</div>
				</div>
			</main>
		</div>

		<!-- 二维码支付弹窗 -->
		<div v-if="showQRCodeModal" class="qr-modal-overlay" @click="closeQRModal">
			<div class="qr-modal" @click.stop>
				<div class="qr-modal-header">
					<h3 class="qr-modal-title">
						{{ selectedPaymentMethod.name }}扫码支付
					</h3>
					<button class="qr-modal-close" @click="closeQRModal">×</button>
				</div>

				<div class="qr-modal-content">
					<!-- 支付信息 -->
					<div class="payment-info">
						<div class="payment-amount">¥{{ finalAmount }}</div>
					</div>

					<!-- 二维码区域 -->
					<div class="qr-code-section">
						<div class="qr-code-container">
							<canvas ref="qrCanvas" class="qr-code"></canvas>
						</div>

						<!-- 支付状态 -->
						<div class="payment-status">
							<div v-if="paymentStatus === 'generating'" class="status-generating">
								<div class="spinner-small"></div>
								<span>生成支付码中...</span>
							</div>
							<div v-else-if="paymentStatus === 'waiting'" class="status-waiting">
								<div class="pulse-dot"></div>
								<span>请使用{{ selectedPaymentMethod.name }}扫码支付</span>
							</div>
							<div v-else-if="paymentStatus === 'success'" class="status-success">
								<div class="success-icon">✓</div>
								<span>支付成功！</span>
							</div>
							<div v-else-if="paymentStatus === 'failed'" class="status-failed">
								<div class="failed-icon">✗</div>
								<span>支付失败，请重试</span>
							</div>
							<div v-else-if="paymentStatus === 'timeout'" class="status-timeout">
								<div class="timeout-icon">⏰</div>
								<span>支付超时，请重新生成二维码</span>
							</div>
						</div>

						<!-- 倒计时 -->
						<div v-if="paymentStatus === 'waiting'" class="payment-countdown">
							<div class="countdown-text">
								二维码有效期：{{ formatTime(countdown) }}
							</div>
							<div class="countdown-bar">
								<div class="countdown-progress" :style="{ width: countdownPercent + '%' }"></div>
							</div>
						</div>

						<!-- 操作按钮 -->
						<div class="qr-actions">
							<button v-if="paymentStatus === 'waiting'" class="refresh-btn" @click="refreshQRCode">
								<span class="refresh-icon">↻</span>
								刷新二维码
							</button>
							<button v-if="paymentStatus === 'timeout' || paymentStatus === 'failed'" class="retry-btn"
								@click="retryPayment">
								重新生成
							</button>
							<button v-if="paymentStatus === 'success'" class="complete-btn" @click="closeQRModal">
								完成
							</button>
						</div>
					</div>

					<!-- 支付说明 -->
					<div class="payment-tips">
						<div class="tips-title">支付说明：</div>
						<ul class="tips-list">
							<li>请在{{ formatTime(300) }}内完成支付</li>
							<li>支付成功后FF币将自动到账</li>
							<li>如有问题请联系客服</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '@/components/Breadcrumb.vue'
	import QRCode from 'qrcode'
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'TalentServicePage',
		components: {
			Breadcrumb
		},
		data() {
			return {
				isLoading: false,
				showQRCodeModal: false,
				paymentStatus: 'waiting', // generating, waiting, success, failed, timeout
				paymentOrderId: null,
				countdown: 300, // 5分钟倒计时
				countdownTimer: null,
				paymentCheckTimer: null,
				qrCodeData: '',
				userInfo: {
					name: '张工程师',
					ffCoins: 1280
				},
				selectedAmount: 100, // 默认选中100元
				selectedPayment: 'wechat',
				useCustomAmount: false,
				customAmount: '',
				amountOptions: [{
						id: 1,
						money: 0.01,
						ff: 10,
						bonus: 0,
						bonusText: '优惠'
					},
					{
						id: 2,
						money: 50,
						ff: 500,
						bonus: 50,
						bonusText: '优惠'
					},
					{
						id: 3,
						money: 100,
						ff: 1000,
						bonus: 150,
						bonusText: '优惠'
					},
					{
						id: 4,
						money: 200,
						ff: 2000,
						bonus: 400,
						bonusText: '优惠'
					},
					{
						id: 5,
						money: 500,
						ff: 5000,
						bonus: 1200,
						bonusText: '优惠'
					},
					{
						id: 6,
						money: 1000,
						ff: 10000,
						bonus: 3000,
						bonusText: '优惠'
					}
				],
				paymentMethods: [{
					id: 'wechat',
					name: '微信支付',
					icon: '💚', // 保留作为备用
					class: 'wechat'
				}],
				orderNo: '',
				activeTab: 'recharge',
				// 数据
				rechargeHistory: [],
				consumeHistory: []
			}
		},
		computed: {
			...mapGetters([
				'currentUser'
			]),
			finalAmount() {
				if (this.useCustomAmount) {
					return Number(this.customAmount) || 0;
				}
				return this.selectedAmount || 0;
			},
			canRecharge() {
				return this.finalAmount > 0 && this.selectedPayment && !this.isLoading;
			},
			selectedPaymentMethod() {
				return this.paymentMethods.find(m => m.id === this.selectedPayment) || this.paymentMethods[0];
			},
			countdownPercent() {
				return (this.countdown / 300) * 100;
			},
			tokenBalance() {
				return this.$store.state.tokenBalance;
			}
		},
		mounted() {
			//this.getUserInfo()
			this.loadRechargeData();
		},
		methods: {

			// 切换标签
			switchTab(tab) {
				this.activeTab = tab;
				if (tab === 'recharge' && this.rechargeHistory.length === 0) {
					this.loadRechargeData();
				} else if (tab === 'consume' && this.consumeHistory.length === 0) {
					this.loadConsumeData();
				}
			},

			// 加载充值记录
			loadRechargeData() {
				this.HttpUtils.get('/api/wxmini/token/getPaymentRecord', {
					userId: this.currentUser.userId
				}).then(result => {
					console.log(result.data.data)
					this.rechargeHistory = result.data.data?result.data.data:[]
				})
			},
			// 加载消费记录
			loadConsumeData() {
				this.HttpUtils.get('/api/wxmini/token/getFlowByUser', {
					userId: this.currentUser.userId
				}).then(result => {
					console.log(result.data.data)
					this.consumeHistory = result.data.data?result.data.data:[]
				})
			},
			//查询余额
			getUserInfo() {
				this.HttpUtils.get('/api/wxmini/getUserInfo', {
					phone: this.currentUser.phonenumber
				}).then(result => {
					console.log(result.data.data)
					this.userInfo.ffCoins = result.data.data.tokenBalance;
					this.$store.commit('updateTokenBalance', result.data.data.tokenBalance);
				})
			},
			selectAmount(option) {
				this.selectedAmount = option.money;
				this.useCustomAmount = false;
				this.customAmount = '';
			},
			onCustomAmountChange() {
				if (this.useCustomAmount) {
					this.selectedAmount = null;
				}
			},
			calculateFFCoins() {
				let ffAmount = this.finalAmount * 10; // 1元=10FF币基础比例

				// 添加赠送的FF币
				if (!this.useCustomAmount && this.selectedAmount) {
					const selectedOption = this.amountOptions.find(opt => opt.money === this.selectedAmount);
					if (selectedOption && selectedOption.bonus) {
						ffAmount += selectedOption.bonus;
					}
				}

				return ffAmount.toLocaleString();
			},
			async handleRecharge() {
				if (!this.canRecharge) return;

				this.isLoading = true;

				try {
					// 生成订单ID
					this.paymentOrderId = 'FF' + Date.now();

					// 显示二维码弹窗
					this.showQRCodeModal = true;
					this.paymentStatus = 'generating';

					// 生成支付二维码
					await this.generateQRCode();

				} catch (error) {
					console.error('生成支付码失败:', error);
					this.isLoading = false;
					alert('生成支付码失败，请重试');
				}
			},

			// Native支付生成支付链接
			async generatePaymentCode(paymentType, orderId, amount) {
				try {
					// 准备请求参数
					const requestParams = {
						amount: amount * 100, // 支付金额（必需）
						goodsName: '描述', // 商品描述（必需）  
						userId: this.currentUser.userId, // 用户ID（必需）
					};

					// 调用封装的post方法
					const result = await this.HttpUtils.post('/api/wxmini/wxpay/unifiedH5Order', requestParams);
					console.log('------------', result)
					// 检查业务响应
					if (result.data.code === 200) { // 根据后端实际返回格式调整
						// 返回支付链接，如：weixin://wxpay/bizpayurl?pr=xxx
						this.orderNo = result.data.data.orderNo;
						return result.data.data?.webUrl || result.data.data.webUrl; // 根据后端实际字段调整
					} else {
						throw new Error(result.data.message || result.data.msg || '生成支付码失败');
					}

				} catch (error) {
					console.error('生成支付码失败:', error);

					// 生产环境直接抛出错误
					throw error;
				}
			},

			// 使用qrcode库生成二维码
			async showQRCode(canvas, codeURL) {
				try {
					await QRCode.toCanvas(canvas, codeURL, {
						width: 200,
						height: 200,
						margin: 2,
						color: {
							dark: '#000000',
							light: '#FFFFFF'
						}
					});
					console.log('二维码生成成功');
				} catch (error) {
					console.error('二维码生成失败:', error);
					throw error;
				}
			},

			async generateQRCode() {
				try {
					// 生成支付链接
					const codeUrl = await this.generatePaymentCode(
						this.selectedPayment,
						this.paymentOrderId,
						this.finalAmount
					);

					this.qrCodeData = codeUrl;

					// 生成二维码
					const canvas = this.$refs.qrCanvas;
					if (canvas) {
						await this.showQRCode(canvas, codeUrl);
					}

					// 更新状态
					this.paymentStatus = 'waiting';
					this.isLoading = false;

					// 开始倒计时
					this.startCountdown();

					// 开始检查支付状态
					this.startPaymentCheck();

				} catch (error) {
					console.error('生成二维码失败:', error);
					this.paymentStatus = 'failed';
					this.isLoading = false;
				}
			},

			startCountdown() {
				this.countdown = 300; // 5分钟
				this.countdownTimer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						this.clearTimers();
						this.paymentStatus = 'timeout';
						// 超时后立即作废二维码
						this.invalidateCurrentQRCode();
					}
				}, 1000);
			},
			startPaymentCheck() {
				// 模拟检查支付状态
				this.paymentCheckTimer = setInterval(async () => {
					try {
						// 这里应该调用实际的支付状态查询接口
						const isSuccess = await this.checkPaymentStatus();
						if (isSuccess) {
							this.handlePaymentSuccess();
						}
					} catch (error) {
						console.error('检查支付状态失败:', error);
					}
				}, 3000);
			},
			async checkPaymentStatus() {
				try {
					// 查询支付状态接口
					const result = await this.HttpUtils.get('/api/wxmini/wxpay/orderquery', {
						userId: this.currentUser.userId,
						orderNo: this.orderNo
					});

					console.log('支付状态查询结果:', result);

					if (result.data.code === 200) {
						// 根据后端返回的状态判断
						const status = result.data.data.trade_state;
						// 后端可能返回：NOTPAY, SUCCESS, CLOSED, USERPAYING, PAYERROR 等
						if (status === 'SUCCESS') {
							console.log('支付成功');
							this.loadRechargeData();
							return true; // 支付成功
						} else if (status === 'CLOSED' || status === 'PAYERROR') {
							// 订单已关闭或支付失败，作废当前二维码
							this.invalidateCurrentQRCode();
							return false;
						}
						return false; // 其他状态都是未支付
					}

					return false;

				} catch (error) {
					console.error('查询支付状态失败:', error);
					return false;
				}
			},
			// 作废当前二维码
			async invalidateCurrentQRCode() {
				try {
					if (this.orderNo) {
						// 调用后端接口关闭订单，作废二维码
						await this.HttpUtils.post('/api/wxmini/wxpay/closeorder', {
							userId: this.currentUser.userId,
							orderNo: this.orderNo
						});
						console.log('二维码已作废:', this.orderNo);
					}
				} catch (error) {
					console.error('作废二维码失败:', error);
				}
			},
			handlePaymentSuccess() {
				this.clearTimers();
				this.paymentStatus = 'success';

				this.getUserInfo();
				// 自动关闭弹窗（3秒后）
				setTimeout(() => {
					this.closeQRModal();
				}, 3000);
			},
			refreshQRCode() {
				// 刷新前先作废旧的二维码
				if (this.orderNo) {
					this.invalidateCurrentQRCode();
				}
				this.clearTimers();
				this.generateQRCode();
			},
			retryPayment() {
				// 重试前先作废旧的二维码
				if (this.orderNo) {
					this.invalidateCurrentQRCode();
				}
				this.generateQRCode();
			},
			closeQRModal() {
				// 关闭弹窗前，如果订单还未完成，先作废二维码
				if (this.paymentStatus !== 'success' && this.orderNo) {
					this.invalidateCurrentQRCode();
				}
				this.showQRCodeModal = false;
				this.paymentStatus = 'waiting';
				this.clearTimers();

				// 重置选择
				this.selectedAmount = 100; // 保持默认选中100元
				this.useCustomAmount = false;
				this.customAmount = '';
			},
			clearTimers() {
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				if (this.paymentCheckTimer) {
					clearInterval(this.paymentCheckTimer);
					this.paymentCheckTimer = null;
				}
			},
			formatTime(seconds) {
				const minutes = Math.floor(seconds / 60);
				const remainingSeconds = seconds % 60;
				return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
			}
		},
		beforeDestroy() {
			// 组件销毁前作废未完成的订单
			if (this.paymentStatus !== 'success' && this.orderNo) {
				this.invalidateCurrentQRCode();
			}
			this.clearTimers();
		}
	}
</script>

<style scoped>
	/* 用户信息 */
	.user-info {
		position: relative;
		display: flex;
		align-items: center;
		gap: 15px;
		padding: 8px 20px;
		background: var(--light-blue);
		border-radius: 25px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.user-info:hover {
		background: var(--primary-blue);
		color: white;
	}

	.user-avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: var(--primary-blue);
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
	}

	.user-name {
		font-weight: 500;
	}

	.ff-coins {
		display: flex;
		align-items: center;
		gap: 5px;
		padding: 5px 12px;
		background: rgba(255, 193, 7, 0.1);
		border-radius: 15px;
		color: #f57c00;
		font-weight: 600;
	}

	.ff-icon {
		width: 20px;
		height: 20px;
		background: linear-gradient(135deg, #ffc107, #ff9800);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 12px;
		font-weight: bold;
	}

	/* 主要内容区域 */
	.main-content {
		padding: 40px 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 40px;
	}

	.page-header {
		text-align: center;
		margin-bottom: 40px;
	}

	.page-title {
		font-size: 32px;
		font-weight: 700;
		color: var(--text-dark);
		margin-bottom: 10px;
	}

	.page-subtitle {
		font-size: 16px;
		color: var(--text-light);
	}

	/* 充值区域 */
	.recharge-container {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 40px;
		padding-bottom: 40px;
	}

	/* 余额卡片 */
	.balance-card {
		background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
		border-radius: 16px;
		padding: 30px;
		color: white;
		text-align: center;
		box-shadow: 0 8px 32px rgba(13, 71, 161, 0.2);
	}

	.balance-title {
		font-size: 16px;
		margin-bottom: 15px;
		opacity: 0.9;
	}

	.balance-amount {
		font-size: 48px;
		font-weight: 700;
		margin-bottom: 10px;
	}

	.balance-desc {
		font-size: 14px;
		opacity: 0.8;
	}

	/* 充值选项 */
	.recharge-panel {
		background: white;
		border-radius: 16px;
		padding: 30px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
		border: 1px solid var(--gray-border);
	}

	.recharge-title {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 20px;
		color: var(--text-dark);
	}

	.amount-options {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 15px;
		margin-bottom: 25px;
	}

	.amount-option {
		border: 2px solid var(--gray-border);
		border-radius: 12px;
		padding: 20px 15px;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s;
		position: relative;
	}

	.amount-option:hover {
		border-color: var(--primary-blue);
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(13, 71, 161, 0.1);
	}

	.amount-option.selected {
		border-color: var(--primary-blue);
		background: var(--light-blue);
	}

	.amount-money {
		font-size: 20px;
		font-weight: 600;
		color: var(--text-dark);
		margin-bottom: 5px;
	}

	.amount-ff {
		font-size: 14px;
		color: var(--text-light);
		margin-bottom: 5px;
	}

	.amount-bonus {
		font-size: 12px;
		color: var(--warning);
		font-weight: 500;
	}

	.bonus-tag {
		position: absolute;
		top: -8px;
		right: -8px;
		background: var(--warning);
		color: white;
		font-size: 10px;
		padding: 2px 6px;
		border-radius: 8px;
		font-weight: 600;
	}

	/* 支付方式 */
	.payment-methods {
		margin-bottom: 30px;
	}

	.payment-title {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 15px;
		color: var(--text-dark);
	}

	.payment-options {
		display: flex;
		gap: 15px;
	}

	.payment-option {
		flex: 1;
		border: 2px solid var(--gray-border);
		border-radius: 12px;
		padding: 20px 15px;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s;
	}

	.payment-option:hover {
		border-color: var(--primary-blue);
	}

	.payment-option.selected {
		border-color: var(--primary-blue);
		background: var(--light-blue);
	}

	.payment-icon {
		width: 40px;
		height: 40px;
		margin: 0 auto 10px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
	}

	.payment-icon.wechat {
		background: #07c160;
		color: white;
	}

	.payment-icon svg {
		width: 24px;
		height: 24px;
	}

	.payment-name {
		font-size: 14px;
		font-weight: 500;
		color: var(--text-dark);
	}

	/* 充值按钮 */
	.recharge-btn {
		width: 100%;
		padding: 15px;
		background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
		color: white;
		border: none;
		border-radius: 12px;
		font-size: 18px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s;
		box-shadow: 0 4px 20px rgba(13, 71, 161, 0.2);
	}

	.recharge-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 30px rgba(13, 71, 161, 0.3);
	}

	.recharge-btn:disabled {
		background: var(--gray-border);
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}

	/* 二维码弹窗样式 */
	.qr-modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		backdrop-filter: blur(4px);
	}

	.qr-modal {
		background: white;
		border-radius: 20px;
		width: 450px;
		max-width: 90vw;
		max-height: 90vh;
		overflow-y: auto;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
		animation: modalSlideIn 0.3s ease-out;
	}

	@keyframes modalSlideIn {
		from {
			opacity: 0;
			transform: scale(0.9) translateY(-20px);
		}

		to {
			opacity: 1;
			transform: scale(1) translateY(0);
		}
	}

	.qr-modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 25px 30px 20px;
		border-bottom: 1px solid #f0f0f0;
	}

	.qr-modal-title {
		font-size: 20px;
		font-weight: 600;
		color: var(--text-dark);
		margin: 0;
	}

	.qr-modal-close {
		width: 32px;
		height: 32px;
		border: none;
		background: #f5f5f5;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 18px;
		color: #666;
		transition: all 0.3s;
	}

	.qr-modal-close:hover {
		background: #e0e0e0;
		color: #333;
	}

	.qr-modal-content {
		padding: 30px;
	}

	/* 支付信息 */
	.payment-info {
		text-align: center;
		margin-bottom: 30px;
	}

	.payment-amount {
		font-size: 36px;
		font-weight: 700;
		color: var(--primary-blue);
		margin-bottom: 8px;
	}

	.payment-desc {
		font-size: 14px;
		color: var(--text-light);
	}

	/* 二维码区域 */
	.qr-code-section {
		text-align: center;
	}

	.qr-code-container {
		position: relative;
		display: inline-block;
		margin-bottom: 20px;
		padding: 20px;
		background: white;
		border-radius: 16px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		border: 1px solid #f0f0f0;
	}

	.qr-code {
		display: block;
		border-radius: 8px;
	}

	/* 支付状态 */
	.payment-status {
		margin-bottom: 20px;
	}

	.payment-status>div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		padding: 12px;
		border-radius: 12px;
		font-size: 14px;
		font-weight: 500;
	}

	.status-generating {
		background: rgba(13, 71, 161, 0.1);
		color: var(--primary-blue);
	}

	.status-waiting {
		background: rgba(245, 124, 0, 0.1);
		color: var(--warning);
	}

	.status-success {
		background: rgba(46, 125, 50, 0.1);
		color: var(--success);
	}

	.status-failed {
		background: rgba(211, 47, 47, 0.1);
		color: #d32f2f;
	}

	.status-timeout {
		background: rgba(158, 158, 158, 0.1);
		color: #9e9e9e;
	}

	/* 状态图标 */
	.pulse-dot {
		width: 8px;
		height: 8px;
		background: var(--warning);
		border-radius: 50%;
		animation: pulse 1.5s infinite;
	}

	.success-icon {
		width: 16px;
		height: 16px;
		background: var(--success);
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
	}

	.failed-icon {
		width: 16px;
		height: 16px;
		background: #d32f2f;
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
	}

	.timeout-icon {
		font-size: 16px;
	}

	/* 倒计时 */
	.payment-countdown {
		margin-bottom: 20px;
	}

	.countdown-text {
		font-size: 12px;
		color: var(--text-light);
		margin-bottom: 8px;
	}

	.countdown-bar {
		width: 100%;
		height: 4px;
		background: #f0f0f0;
		border-radius: 2px;
		overflow: hidden;
	}

	.countdown-progress {
		height: 100%;
		background: linear-gradient(90deg, var(--primary-blue), var(--secondary-blue));
		transition: width 1s linear;
	}

	/* 操作按钮 */
	.qr-actions {
		display: flex;
		gap: 10px;
		justify-content: center;
	}

	.qr-actions button {
		padding: 10px 20px;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
	}

	.refresh-btn {
		background: #f5f5f5;
		color: var(--text-dark);
	}

	.refresh-btn:hover {
		background: #e0e0e0;
	}

	.retry-btn {
		background: var(--primary-blue);
		color: white;
	}

	.retry-btn:hover {
		background: var(--secondary-blue);
	}

	.complete-btn {
		background: var(--success);
		color: white;
	}

	.complete-btn:hover {
		background: #2e7d32;
	}

	.refresh-icon {
		display: inline-block;
		animation: rotate 2s linear infinite;
	}

	/* 支付说明 */
	.payment-tips {
		margin-top: 20px;
		padding: 15px;
		background: #f8f9fa;
		border-radius: 12px;
	}

	.tips-title {
		font-size: 14px;
		font-weight: 600;
		color: var(--text-dark);
		margin-bottom: 8px;
	}

	.tips-list {
		margin: 0;
		padding-left: 16px;
		font-size: 12px;
		color: var(--text-light);
		line-height: 1.6;
	}

	.tips-list li {
		margin-bottom: 4px;
	}

	/* 动画 */
	@keyframes pulse {

		0%,
		100% {
			opacity: 1;
			transform: scale(1);
		}

		50% {
			opacity: 0.5;
			transform: scale(1.1);
		}
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	/* 小型加载动画 */
	.spinner-small {
		width: 16px;
		height: 16px;
		border: 2px solid rgba(13, 71, 161, 0.3);
		border-top: 2px solid var(--primary-blue);
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	/* 加载动画 */
	.loading {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.spinner {
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-top: 2px solid white;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.recharge-container {
			grid-template-columns: 1fr;
			gap: 20px;
		}

		.amount-options {
			grid-template-columns: repeat(2, 1fr);
		}

		.payment-options {
			flex-direction: column;
		}

		.container {
			padding: 0 20px;
		}

		.qr-modal {
			width: 95vw;
			margin: 20px;
		}

		.qr-modal-content {
			padding: 20px;
		}
	}

	/* 过渡动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}


	/* 记录历史 */
	.records-section {
		background: white;
		border: 2px solid var(--gray-border);
		border-radius: 12px;
		padding: 30px;
		margin-top: 30px;
	}

	.records-tabs {
		display: flex;
		gap: 20px;
		margin-bottom: 25px;
		border-bottom: 2px solid var(--gray-border);
	}

	.record-tab {
		padding: 12px 20px;
		background: none;
		border: none;
		color: var(--text-light);
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
		border-bottom: 2px solid transparent;
		margin-bottom: -2px;
	}

	.record-tab.active {
		color: var(--primary-blue);
		border-bottom-color: var(--primary-blue);
	}

	.record-tab:hover {
		color: var(--primary-blue);
	}

	.records-content {
		min-height: 200px;
		max-height: 500px;
		overflow-y: scroll;
	}

	.record-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 0;
		border-bottom: 1px solid var(--gray-border);
	}

	.record-item:last-child {
		border-bottom: none;
	}

	.record-info {
		flex: 1;
	}

	.record-title {
		font-size: 15px;
		color: var(--text-dark);
		margin-bottom: 5px;
	}

	.record-date {
		color: var(--text-light);
		font-size: 13px;
	}

	.record-amount {
		font-weight: 600;
		font-size: 16px;
		min-width: 100px;
		text-align: right;
	}

	.record-amount.positive {
		color: var(--success);
	}

	.record-amount.negative {
		color: #d32f2f;
	}

	.empty-records {
		text-align: center;
		color: var(--text-light);
		padding: 40px 20px;
		font-size: 15px;
	}

	.empty-icon {
		font-size: 48px;
		margin-bottom: 15px;
		opacity: 0.5;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		body {
			padding: 15px;
		}

		.records-section {
			padding: 20px 15px;
			border-radius: 8px;
		}

		.records-tabs {
			gap: 15px;
			margin-bottom: 20px;
		}

		.record-tab {
			padding: 10px 15px;
			font-size: 15px;
		}

		.record-item {
			flex-direction: column;
			align-items: flex-start;
			padding: 12px 0;
			gap: 8px;
		}

		.record-amount {
			min-width: auto;
			text-align: left;
			font-size: 18px;
		}

		.record-title {
			font-size: 14px;
		}

		.record-date {
			font-size: 12px;
		}

		.empty-records {
			padding: 30px 15px;
			font-size: 14px;
		}

		.empty-icon {
			font-size: 40px;
			margin-bottom: 12px;
		}
	}

	@media (max-width: 480px) {
		body {
			padding: 10px;
		}

		.records-section {
			padding: 15px 12px;
		}

		.records-tabs {
			gap: 10px;
			margin-bottom: 15px;
		}

		.record-tab {
			padding: 8px 12px;
			font-size: 14px;
		}

		.record-item {
			padding: 10px 0;
			gap: 6px;
		}

		.record-title {
			font-size: 13px;
			line-height: 1.4;
		}

		.record-date {
			font-size: 11px;
		}

		.record-amount {
			font-size: 16px;
		}

		.empty-records {
			padding: 25px 10px;
			font-size: 13px;
		}

		.empty-icon {
			font-size: 36px;
			margin-bottom: 10px;
		}
	}
</style>